import { client } from "api";
import { CommentType, Comment } from "models/Comment";

export type GetChecklistCommentsRequest = { checklistId: string, type?: CommentType | null };

export type GetChecklistCommentsResponse = Comment[];

export const getChecklistComments = ({ checklistId, type }: GetChecklistCommentsRequest) =>
  client
    .get<GetChecklistCommentsResponse>(
      `/checklist/${checklistId}/comments`,
      { params: { type } }
    )
    .then((res) => res.data);
